﻿import carouselExtTrackCtrl from './carouselExtTrack.ctrl.js';

export const carouselExtTrackComponent = {
    controller: carouselExtTrackCtrl,
    bindings: {},
};
